import React, { useMemo, forwardRef } from 'react';
import styled from 'styled-components';

type Props = {
  htmlText: string;
  className?: string;
  children?: React.ReactNode;
};

const Description = forwardRef<HTMLDivElement, Props>(
  ({ htmlText, className, children }, ref): JSX.Element => {
    const description = useMemo(() => htmlText, [htmlText]);

    return (
      <div
        key={
          description
            ? description.substring(0, 10) + new Date().getTime()
            : undefined
        }
        ref={ref}
        dangerouslySetInnerHTML={
          description
            ? {
                __html: description,
              }
            : undefined
        }
        className={className}
      >
        {children}
      </div>
    );
  }
);

Description.displayName = 'Description';

export default styled(Description)`
  font-size: 14px;
  line-height: 21px;
  text-align: justify;

  h2,
  h3,
  ul {
    text-align: initial;
  }

  h2 {
    font-weight: 600;
    font-size: 18px;
    line-height: 30px;
  }

  h3 {
    font-weight: 600;
    font-size: 14px;
    line-height: 30px;
  }

  ul {
    list-style-type: disc;
    padding-left: 40px;
    font-size: 14px;
    line-height: 21px;

    li {
      display: list-item;
    }
  }

  h2,
  h3,
  p,
  li {
    margin-bottom: 1rem;
  }

  > *:last-child {
    margin-bottom: 0 !important;
  }
`;
